import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { reducer } from './billing-reducer';
import { initialBillingState } from './billing-state';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { EffectsModule } from '@ngrx/effects';
import { BillingEffects } from './billing-effects';
import { BillingDataService } from '@core/data/api/billing/billing-data.service';
// import { BillingSharedModule } from '@features/billing/shared/billing.shared.module';
// import { PlaidLinkModule } from '@components/plaid-link/plaid-link.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from '@components/dialog/dialog.module';

@NgModule({
    imports: [
      StoreModule.forFeature(StateSlice.BILLING, (reducer as ActionReducer<any, any>), {
        initialState: initialBillingState,
        metaReducers: [entityMetaReducer],
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([
        BillingEffects
      ]),
      // BillingSharedModule,
      // PlaidLinkModule,
      
      TranslateModule,
      DialogModule
    ],
    declarations: [],
    providers: [
      BillingDataService
    ]
  })
  export class BillingStateModule {}